/* t7-3 remate 6 (C, #576): DIAS DE CALENDARIO ENTRE DOS INSTANTES, en la zona del dispositivo.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Pura y neutra: no importa nada. La usa "Ultimo repaso" de Analiticas (web y app), que hasta este remate
   contaba bloques de 24 horas: lo estudiado anoche a las 23:00 seguia siendo "hoy" a las 10:00 de la manana
   siguiente. Aqui se toma la fecha LOCAL de cada instante (anio, mes y dia del dispositivo), se lleva a
   `Date.UTC` y se restan: asi un cambio de horario (un dia de 23 o de 25 horas) no mueve la cuenta. Nunca es
   negativa: un instante futuro (un reloj adelantado) cuenta como hoy. Un instante que no se puede leer da
   `null`. */

const DIA_MS = 86400000;

function fechaLocalEnUtc(valor) {
  const d = valor instanceof Date ? valor : new Date(valor);
  const ms = d.getTime();
  if (Number.isNaN(ms)) return null;
  return Date.UTC(d.getFullYear(), d.getMonth(), d.getDate());
}

/** Dias de calendario de `antes` a `ahora` (0 = el mismo dia local, 1 = ayer, ...). */
export function diasDeCalendarioEntre(antes, ahora = new Date()) {
  const a = fechaLocalEnUtc(antes);
  const b = fechaLocalEnUtc(ahora);
  if (a === null || b === null) return null;
  return Math.max(0, Math.round((b - a) / DIA_MS));
}

/** El texto de "Ultimo repaso" con las formas que ya existen en los locales (`study`): hoy, o "hace n dia(s)"
    con el plural de i18next. `null` si el instante no se puede leer (la pagina entonces no pinta nada). */
export function textoDelUltimoRepaso(t, instante, ahora = new Date()) {
  const dias = diasDeCalendarioEntre(instante, ahora);
  if (dias === null) return null;
  if (dias === 0) return t('analytics.days_ago.today');
  return t('analytics.days_ago.ago', { count: dias });
}

export default diasDeCalendarioEntre;
